// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-link[data-v-61406b07]{display:inline-block;color:#c4c4c4;line-height:1.1875rem;text-decoration:none;border-bottom:1px dotted #c4c4c4}", ""]);
// Exports
module.exports = exports;
